export enum ColorsEnum {
  transparentGray = "#00000066",
  transparent = "#00000000",
  white = "#fff",
  smokeWhite = "#eee",
  whiteBlue = "#ecf0f5",
  black = "#333",
  gray = "#aaa",
  dimGray = "#888",
  lightGray = "#ccc",
  darkSlateGray = "#222d32",
  darkGray = "#282c34",
  blue = "#2196c4",
  green = "#5cb85c",
  limeGreen = "#75FA4C",
  bluishGreenish = "#0097BA21",
  seaGreen = "#74B666",
  lightGreen = "#BADBB3",
  red = "#EB7171",
  lightRed = "#F5B8B8",
  orange = "#F8A934",
  darkOrange = "#f39c12",
  yellow = "#FFFF00",
  lightYellow = "#ffcf40bd",
  pink = "#FFB6C1",
  translucentPink = "#FF62A521",
  vipGold = "#ffcf40",
  goldenSunshine = "#FFD646",
  deepSkyBlue = "#00BFFF",
  bondiBlue = "#0097BA",
  maastrichtBlue = "#0D1F3C",
  davysGrey = "#5A5A5A",
  cyan = "#05F0FF",
  borderBlue = "#CDE9F3",
  lavenderIndigo = "#9645E9",
  shadeOfBlueDark = "#2854C5",
  paleGrayishWhite = "#F9F9F9",
  paleBluishGray = "#EFF1F5",
  vibrantPinkishMagenta = "#EF72A7",
  shadeOfGray = "#E1E1E1",
  blueGray = "#F6FAFF",
  purple = "#583ECC",
  lightPurple = "#583eccbf",
  brightCyan = "#4195A5",
  dodgerBlue = "#2584ff",
  mutedSteelBlue = "#486A84",
  plumBrown = "#633B48",
  bronzedGold = "#A2845E",
  powerPurple = "#AF52DE",
  paleSkyBlue = "#CCEAF1",
  palePink = "#FFE1EB",
  translucentWhite = "#FFFFFF40",
  vividRed = "#E40000"
}

export const colors = {
  all: {
    transparentGray: ColorsEnum.transparentGray,
    transparent: ColorsEnum.transparent,
    white: ColorsEnum.white,
    smokeWhite: ColorsEnum.smokeWhite,
    whiteBlue: ColorsEnum.whiteBlue,
    black: ColorsEnum.black,
    gray: ColorsEnum.gray,
    dimGray: ColorsEnum.dimGray,
    lightGray: ColorsEnum.lightGray,
    darkSlateGray: ColorsEnum.darkSlateGray,
    darkGray: ColorsEnum.darkGray,
    blue: ColorsEnum.blue,
    green: ColorsEnum.green,
    limeGreen: ColorsEnum.limeGreen,
    bluishGreenish: ColorsEnum.bluishGreenish,
    seaGreen: ColorsEnum.seaGreen,
    red: ColorsEnum.red,
    orange: ColorsEnum.orange,
    darkOrange: ColorsEnum.darkOrange,
    yellow: ColorsEnum.yellow,
    lightYellow: ColorsEnum.lightYellow,
    pink: ColorsEnum.pink,
    translucentPink: ColorsEnum.translucentPink,
    vipGold: ColorsEnum.vipGold,
    goldenSunshine: ColorsEnum.goldenSunshine,
    deepSkyBlue: ColorsEnum.deepSkyBlue,
    bondiBlue: ColorsEnum.bondiBlue,
    maastrichtBlue: ColorsEnum.maastrichtBlue,
    davysGrey: ColorsEnum.davysGrey,
    cyan: ColorsEnum.cyan,
    borderBlue: ColorsEnum.borderBlue,
    lavenderIndigo: ColorsEnum.lavenderIndigo,
    shadeOfBlueDark: ColorsEnum.shadeOfBlueDark,
    paleGrayishWhite: ColorsEnum.paleGrayishWhite,
    paleBluishGray: ColorsEnum.paleBluishGray,
    vibrantPinkishMagenta: ColorsEnum.vibrantPinkishMagenta,
    shadeOfGray: ColorsEnum.shadeOfGray,
    lightGreen: ColorsEnum.lightGreen,
    lightRed: ColorsEnum.lightRed,
    blueGray: ColorsEnum.blueGray,
    purple: ColorsEnum.purple,
    lightPurple: ColorsEnum.lightPurple,
    brightCyan: ColorsEnum.brightCyan,
    dodgerBlue: ColorsEnum.dodgerBlue,
    mutedSteelBlue: ColorsEnum.mutedSteelBlue,
    plumBrown: ColorsEnum.plumBrown,
    bronzedGold: ColorsEnum.bronzedGold,
    powerPurple: ColorsEnum.powerPurple,
    paleSkyBlue: ColorsEnum.paleSkyBlue,
    palePink: ColorsEnum.palePink,
    translucentWhite: ColorsEnum.translucentWhite,
    vividRed: ColorsEnum.vividRed
  }
};
